/**
 * The active tool the user currently has selected
 */
import { SET_ACTIVE_TOOL } from "../actionTypes.js";
import { replaceReducer } from "./common/index.js";
export default replaceReducer(SET_ACTIVE_TOOL, null);
//# sourceMappingURL=activeTool.js.map